import { motion } from "framer-motion";

const STEPS = [
  {
    title: "Inteligencia de Mercado y Scouting Global",
    desc: "Identificamos tendencias tecnológicas y seleccionamos fabricantes internacionales de primer nivel, garantizando productos de alta demanda y precios de origen.",
    image:
      "https://customer-assets.emergentagent.com/job_nexora-contact-hub/artifacts/t000461s_Metodolog%C3%ADa.%20Paso%201..webp",
  },
  {
    title: "Gestión Logística e Importación Directa",
    desc: "Ejecutamos el proceso de importación sin intermediarios, optimizando tiempos aduanales y costos para asegurar un flujo de stock constante y competitivo en el país.",
    image:
      "https://customer-assets.emergentagent.com/job_nexora-contact-hub/artifacts/ft48eac2_Metodolog%C3%ADa.%20Paso%202.%20.webp",
  },
  {
    title: "Control de Calidad y Certificación Técnica",
    desc: "Cada lote es inspeccionado por nuestro equipo de ingenieros antes de su distribución, validando que componentes y repuestos cumplan con los estándares de garantía Nexora.",
    image:
      "https://customer-assets.emergentagent.com/job_nexora-contact-hub/artifacts/9k1uxs19_Metodolog%C3%ADa.%20Paso%203..webp",
  },
  {
    title: "Distribución Omnicanal Dinámica",
    desc: "Suministramos a mayoristas y minoristas mediante un sistema de gestión ágil que prioriza la velocidad de entrega y la integridad de los equipos de telecomunicaciones y electrónica.",
    image:
      "https://customer-assets.emergentagent.com/job_nexora-contact-hub/artifacts/dtgkvg88_Metodolog%C3%ADa.%20Paso%204..webp",
  },
  {
    title: "Ecosistema de Soporte y Postventa Integral",
    desc: "Cerramos el ciclo ofreciendo instalación especializada, servicios de fibra óptica y un centro de mantenimiento permanente que protege la inversión de nuestros socios comerciales.",
    image:
      "https://customer-assets.emergentagent.com/job_nexora-contact-hub/artifacts/rmol41kc_Metodolog%C3%ADa.%20Paso%205..webp",
  },
];

export const Metodologia = () => {
  return (
    <section
      id="metodologia"
      data-testid="metodologia-section"
      className="relative py-20 md:py-28 bg-[#3B3838] text-white overflow-hidden"
    >
      <div className="absolute inset-0 tech-grid-bg-dark opacity-60" />
      <svg
        className="absolute inset-0 w-full h-full pointer-events-none opacity-50"
        preserveAspectRatio="none"
        viewBox="0 0 1400 1000"
      >
        <path className="circuit-line" d="M0 200 L400 200 L460 260 L900 260 L960 200 L1400 200" />
        <path className="circuit-line alt" d="M0 800 L300 800 L360 740 L1100 740 L1160 800 L1400 800" />
      </svg>

      <div className="relative max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="max-w-3xl mb-14">
          <div className="font-mono-tech text-[11px] tracking-[0.32em] uppercase text-[#FCD7C5] mb-4 flex items-center gap-2">
            <span className="h-px w-8 bg-[#843C0C]" />
            Procesos
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]">
            Metodología de trabajo Nexora.
          </h2>
          <p className="mt-5 text-white/70 text-base md:text-lg leading-relaxed">
            Un flujo operativo de cinco fases técnicas que conecta a fabricantes globales
            con el consumidor final mexicano sin perder calidad ni velocidad.
          </p>
        </div>

        <div className="space-y-6 md:space-y-10">
          {STEPS.map((s, i) => {
            const reverse = i % 2 === 1;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
                className="grid grid-cols-1 lg:grid-cols-12 gap-0 bg-[#2c2929] border border-white/10 hover:border-[#843C0C]/60 transition-colors group"
                data-testid={`metodo-step-${i}`}
              >
                {/* Image */}
                <div
                  className={`lg:col-span-5 relative overflow-hidden aspect-square lg:aspect-auto lg:min-h-[380px] ${
                    reverse ? "lg:order-2" : ""
                  }`}
                >
                  <img
                    src={s.image}
                    alt={`Paso ${i + 1}: ${s.title}`}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div
                    className={`absolute inset-0 pointer-events-none ${
                      reverse
                        ? "bg-gradient-to-l from-[#2c2929] via-transparent to-transparent"
                        : "bg-gradient-to-r from-[#2c2929] via-transparent to-transparent"
                    } opacity-40 lg:opacity-60`}
                  />
                  <div className="absolute top-4 left-4 flex items-baseline gap-2 bg-[#3B3838]/80 backdrop-blur px-3 py-2 border border-[#843C0C]">
                    <span className="font-mono-tech text-[10px] tracking-[0.28em] uppercase text-[#FCD7C5]">
                      Paso
                    </span>
                    <span className="font-mono-tech text-2xl font-bold text-white leading-none">
                      0{i + 1}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div
                  className={`lg:col-span-7 p-6 md:p-10 lg:p-12 flex flex-col justify-center ${
                    reverse ? "lg:order-1" : ""
                  }`}
                >
                  <div className="flex items-center gap-3 mb-4">
                    <span className="h-px w-10 bg-[#843C0C]" />
                    <span className="font-mono-tech text-[11px] tracking-[0.28em] uppercase text-[#FCD7C5]">
                      Step {i + 1} / 05
                    </span>
                  </div>
                  <h3 className="text-2xl md:text-3xl lg:text-4xl font-semibold tracking-tight leading-[1.1] text-white">
                    {s.title}
                  </h3>
                  <p className="mt-5 text-white/75 text-base md:text-lg leading-relaxed">
                    {s.desc}
                  </p>
                  <div className="mt-7 pt-5 border-t border-white/10 flex items-center justify-between">
                    <span className="font-mono-tech text-[10px] tracking-[0.28em] uppercase text-white/50">
                      Fase operativa
                    </span>
                    <span className="font-mono-tech text-[10px] tracking-[0.28em] uppercase text-[#FCD7C5]">
                      {i < STEPS.length - 1 ? "Siguiente ↓" : "Cierre del ciclo"}
                    </span>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
